const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const authHeader = () => {
  const t = localStorage.getItem("mfc-admin-token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

async function req(path, { method = "GET", body, auth = false } = {}) {
  const headers = { ...(body ? { "Content-Type": "application/json" } : {}), ...(auth ? authHeader() : {}) };
  const resp = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await resp.text();
  let data;
  try { data = text ? JSON.parse(text) : {}; } catch { data = text; }
  if (!resp.ok) {
    const detail = data && data.detail ? data.detail : `Request failed (${resp.status})`;
    const err = new Error(typeof detail === "string" ? detail : "Request failed");
    err.response = { data, status: resp.status };
    throw err;
  }
  return data;
}

export const getProducts = () => req("/products");
export const getTestimonials = () => req("/testimonials");
export const getTransformations = () => req("/transformations");
export const getBlog = () => req("/blog");
export const getBlogPost = (slug) => req(`/blog/${slug}`);
export const getFaqs = () => req("/faqs");
export const postContact = (data) => req("/contact", { method: "POST", body: data });
export const postApplication = (data) => req("/applications", { method: "POST", body: data });
export const postNewsletter = (data) => req("/newsletter", { method: "POST", body: data });
export const postOrder = (data) => req("/orders", { method: "POST", body: data });

export const streamChat = async (payload, onToken) => {
  const resp = await fetch(`${API}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    onToken(decoder.decode(value, { stream: true }));
  }
};

// ---- Admin ----
export const adminLogin = (data) => req("/auth/login", { method: "POST", body: data });
export const adminMe = () => req("/auth/me", { auth: true });
export const adminStats = () => req("/admin/stats", { auth: true });
export const adminList = (kind) => req(`/admin/${kind}`, { auth: true });

// ---- Public content ----
export const getVideoTestimonials = () => req("/video-testimonials");
export const getSiteSettings = () => req("/site-settings");

// ---- Admin CMS ----
export const adminCreate = (kind, body) => req(`/admin/${kind}`, { method: "POST", body, auth: true });
export const adminUpdate = (kind, id, body) => req(`/admin/${kind}/${id}`, { method: "PUT", body, auth: true });
export const adminDelete = (kind, id) => req(`/admin/${kind}/${id}`, { method: "DELETE", auth: true });
export const adminSiteSettingsUpdate = (body) => req("/admin/site-settings", { method: "PUT", body, auth: true });
export const adminSendDigest = () => req("/admin/digest/send-now", { method: "POST", auth: true });
export const adminPreviewDigest = () => req("/admin/digest/preview", { auth: true });

export const adminUpload = async (file) => {
  const token = localStorage.getItem("mfc-admin-token");
  const fd = new FormData();
  fd.append("file", file);
  const resp = await fetch(`${API}/admin/upload`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  if (!resp.ok) throw new Error((await resp.text()) || "Upload failed");
  return resp.json(); // { path, url, content_type, size }
};
